import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Menu, MenuItem, Typography} from "@mui/material";

export default function ButtonMenu({name, onView, onSend, startIcon, disabled = false}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [confirmSendOpen, setConfirmSendOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleView = () => {
        handleClose();
        onView();
    };

    const handleSendClick = () => {
        handleClose();
        setConfirmSendOpen(true);
    };

    const handleConfirmSend = () => {
        setConfirmSendOpen(false);
        onSend();
    };

    const handleCancelSend = () => {
        setConfirmSendOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                disabled={disabled}
                startIcon={startIcon}
                variant="outlined"
                fullWidth
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                {name}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuItem onClick={handleView}>Visualiser</MenuItem>
                <MenuItem onClick={handleSendClick}>Envoyer</MenuItem>
            </Menu>
            <Dialog open={confirmSendOpen} onClose={handleCancelSend}>
                <DialogTitle>Confirmer l'envoi</DialogTitle>
                <DialogContent>
                    <Typography>Souhaitez-vous envoyer ce document par email ?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelSend}>Annuler</Button>
                    <Button variant="contained" onClick={handleConfirmSend}>Envoyer</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
